import { render, staticRenderFns } from "./CustomNaming.vue?vue&type=template&id=18839b0e"
import script from "./CustomNaming.vue?vue&type=script&lang=js"
export * from "./CustomNaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports